// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","profileBanner":"_2Rk6gbJbb1L-1byixU_M5w","profileSection":"AyBeh42BO2LG0j60O_6RG"};